module.exports = __webpack_public_path__ + "static/media/scan-QR-code.e30afa53.png";